import React from 'react';
import { Truck } from 'lucide-react';
import {
  DELIVERY_NOTICE_FULL,
  DELIVERY_NOTICE_PARAGRAPHS,
  DELIVERY_NOTICE_SHORT,
  DELIVERY_NOTICE_TITLE,
} from '@/constants/delivery';

const variants = {
  full: {
    wrapper: 'mb-8 rounded-xl border border-primary/25 bg-primary/8 p-5 md:p-6 shadow-card',
    showTitle: true,
    paragraphs: DELIVERY_NOTICE_PARAGRAPHS,
    textClass: 'font-body-serif text-sm md:text-base text-foreground/90 leading-relaxed',
  },
  banner: {
    wrapper: 'mb-8 rounded-xl border border-primary/25 bg-primary/8 p-5 md:p-6 shadow-card',
    showTitle: true,
    paragraphs: DELIVERY_NOTICE_PARAGRAPHS,
    textClass: 'font-body-serif text-sm md:text-base text-foreground/90 leading-relaxed',
  },
  compact: {
    wrapper: 'rounded-xl border border-border bg-accent/50 p-4',
    showTitle: false,
    text: DELIVERY_NOTICE_SHORT,
    textClass: 'font-ui text-xs text-muted-foreground leading-relaxed',
  },
  inline: {
    wrapper: 'rounded-lg border border-border bg-muted/40 p-3',
    showTitle: false,
    text: DELIVERY_NOTICE_SHORT,
    textClass: 'font-ui text-xs text-muted-foreground leading-relaxed',
  },
};

export function DeliveryNotice({ variant = 'compact', className = '' }) {
  const config = variants[variant] ?? variants.compact;
  const isFull = Boolean(config.paragraphs);

  return (
    <div className={`flex items-start gap-3 ${config.wrapper} ${className}`.trim()}>
      <Truck size={isFull ? 22 : 16} className="text-primary shrink-0 mt-0.5" />
      <div className="min-w-0 flex-1">
        {config.showTitle && (
          <p className="font-serif text-lg font-semibold text-foreground mb-3">{DELIVERY_NOTICE_TITLE}</p>
        )}
        {isFull ? (
          <div className="space-y-3">
            {config.paragraphs.map((paragraph) => (
              <p key={paragraph} className={config.textClass}>
                {paragraph}
              </p>
            ))}
          </div>
        ) : (
          <p className={config.textClass}>{config.text}</p>
        )}
      </div>
    </div>
  );
}
